import styled from 'styled-components';

export const Title = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  padding-left: 12px;

  .titleText {
    font-size: ${props => props.theme.font.size.xxs};
    overflow: hidden;
    white-space: nowrap;
  }
`;
